import React from "react";
import Routess from "./routes/routes";
import { isUserLoggedIn } from "./services/utils";
import { useTokenRenewal } from "./services/useTokenRenewal";

function App() {
  const user = isUserLoggedIn();
  useTokenRenewal(user);

  return (
    <div>
      <Routess />
    </div>
  );
}

export default App;
